module.exports = __webpack_public_path__ + "img/fellow.3a958ce5.png";